import useStore from "../../../store"
import DatePicker from "react-datepicker"
import { HappyButton, NeutralButton } from "../../common/Buttons"
import ReusableDrawer from "../../common/ReusableDrawer"
import { Field, Textarea } from "@chakra-ui/react"
import { colors } from "../../../utilities/colors"
import { useTranslation } from "react-i18next"
import { useState } from "react"

export default function MarkArbitrated({ unit }) {
  const { t } = useTranslation()
  const {
    markUnitArbitrated,
    markingUnitArbitrated,
    setErrMessage
  } = useStore()

  const [isOpen, setIsOpen] = useState(false)
  const [arbitratedOnDate, setArbitratedOnDate] = useState(new Date())
  const [note, setNote] = useState("")
  const [isNoteError, setIsNoteError] = useState(false)

  const handleSubmit = async () => {
    if (!arbitratedOnDate) {
      setErrMessage(t("Date Arbitrated is a required field"))
      return
    }

    if (!note.trim()) {
      setErrMessage(t("Note is a required field"))
      setIsNoteError(true)
      return
    }
    setIsNoteError(false)

    const isMarkedArbitrated = await markUnitArbitrated(unit, arbitratedOnDate.toLocaleDateString('en-ZA'), note)

    if (isMarkedArbitrated) {
      setNote("")
      setIsOpen(false)
    }
  }

  return(
    <>
      <NeutralButton
        text={t("Mark Arbitrated")}
        loading={markingUnitArbitrated}
        onClick={() => setIsOpen(true)}
        dataTestId="mark-arbitrated-button"
      />
      <ReusableDrawer
        title={t("Mark Arbitrated")}
        onClose={() => setIsOpen(false)}
        isOpen={isOpen}
        placement="bottom"
      >
        <div className="flex items-center mb-2">
          <label className="text-sm text-grey-300 mr-2">{t("Date Arbitrated")}</label>
          <DatePicker
            selected={arbitratedOnDate}
            onChange={(date) => setArbitratedOnDate(date)}
            className="px-4 w-32 ml-1 bg-grey-900 border-2 border-grey-700 focus:border-grey-300 focus:ring-0 rounded"
            required
          />
        </div>

        <Field.Root id="arbitrated-note" mb={4}>
          <Field.Label fontSize="sm" color={colors.grey300} htmlFor="arbitrated-note">
            {t("Note")}
          </Field.Label>
          <Textarea
            id="arbitrated-note"
            value={note}
            onChange={(e) => setNote(e.target.value)}
            bgColor={colors.grey900}
            borderWidth={2}
            borderColor={isNoteError ? colors.fpxRed : colors.grey700}
            borderRadius="md"
            _focus={{ borderColor: isNoteError ? colors.fpxRed : colors.grey100, ringColor: "transparent" }}
            required
          />
        </Field.Root>

        <HappyButton
          dataTestId="submit-mark-arbitrated"
          text={t("Mark Unit Arbitrated")}
          onClick={handleSubmit}
          loading={markingUnitArbitrated}
        />
      </ReusableDrawer>
    </>
  )
}
